<template>
    <div class="new-client">
      <el-form :model="clientData" ref="clientData" label-width="200px" class="new-client-form">

        <el-form-item label="Name" prop="name">
          <el-input v-model="clientData.name"></el-input>
        </el-form-item>

        <el-form-item label="Address" prop="address">
          <el-input v-model="clientData.address"></el-input>
        </el-form-item>

        <el-form-item label="Latitude" prop="lat">
          <el-input v-model="clientData.lat"></el-input>
        </el-form-item>

        <el-form-item label="Longitude" prop="long">
          <el-input v-model="clientData.long"></el-input>
        </el-form-item>

        <el-form-item label="Zoom" prop="zoom">
          <el-input v-model="clientData.zoom"></el-input>
        </el-form-item>

        <el-form-item label="Sunset Offset (minutes before)" prop="sunset_offset">
          <el-input-number v-model="clientData.sunset_offset"></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="save" @click="submit('clientData')">Create</el-button>
          <el-button type="cancel" @click="close">Cancel</el-button>
        </el-form-item>

      </el-form>
    </div>

</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-new-client',
  data () {
    return {
      pageName: 'New Client',
      clientData: {
        name: '',
        address: '',
        long: '',
        lat: '',
        zoom: '',
      },
    }
  },
  methods: {
    newClient(){

      var context = this;
      var tempData = this.clientData;
      requests.newClient(this, context.clientData, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created client ' + tempData.name
          });

          context.close();         
           
        } else {
          if(result.message) { 
            context.$message({
              showClose: true,
              type: 'error',
              message: result.message
            });
          } else {
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Failed to create new client: ' + result.msg
            });
          }
        }
      })
    },
    submit(formName) {
      // console.log(this.userData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newClient();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('clientData');        
      this.$emit('close');
    }
  },
  beforeMount() {
    
  }
}
</script>



// WEBPACK FOOTER //
// NewClient.vue?19034033